import { ISelectable } from '@app/shared/models/selectable.interface';

export class Db {
  databaseName: string;
  serverName: string;
  data: any;

  constructor(database?: string, server?: string, data?: any) {
    this.databaseName = database;
    this.serverName = server;
    this.data = data;
  }
}

export class UserDb implements ISelectable {
  databaseName: string;
  connectionStringName: string;
  selected?: boolean;
}
